import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { defaultNS } from 'next-i18next.config';
import PATHS from 'lib/navigation/paths';
import { API } from 'lib/config/axios';
import { serverFetch } from 'lib/utils/serverFetch';
import generateHreflang from 'lib/utils/generateHreflang';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { HydrationWrapper } from 'views/common/components';
import isCrawlers from 'lib/utils/isCrawlers';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';

const RentMyMotorcycleView = dynamic(() => import('views/RentMyMotorcycleView').then(
  (file) => file.RentMyMotorcycleView,
));

const ListYourBike = (props) => {
  const { serverData, ssrRender } = props;
  const { isCrawler } = useSelector((state) => state.globalData);

  if (isCrawler) {
    return (
      <HydrationWrapper>
        <RentMyMotorcycleView serverData={serverData} ssrRender={ssrRender} />
      </HydrationWrapper>
    );
  }
  return <RentMyMotorcycleView serverData={serverData} ssrRender={ssrRender} />;
};

export async function getServerSideProps(ctx) {
  const {
    locale, req, res, pathname,
  } = ctx;
  const ssrRender = isCrawlers(req.headers['user-agent']);
  let layoutData = null;
  let serverData = null;
  let serverError = null;

  if (pathname != '/_error') {
    const [layoutRes, seoValuesRes] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.seoValues),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (seoValuesRes.success && seoValuesRes.data) {
      serverData = { seo_values: seoValuesRes.data };
    } else {
      serverError = {
        statusCode: seoValuesRes?.error?.response?.status,
      };
    }
  }
  const hreflangData = generateHreflang(
    PATHS.rentMyMotorcycle().url,
    ctx.locale,
  );
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_rent_my_motorcycle',
        'fe_er_commissionBanner',
      ])),
      hreflangData,
      serverData,
      layoutData,
      ssrRender,
      serverError,
      pageIdentifier: 'rent-my-motorcycle',
      options: {
        showAiChat: true,
      },
    },
  };
}

export default ListYourBike;
